import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { AVAILABILITY_LABELS, COLORS } from "../constants";

function ServiceDetailInfo({ item }) {
  return (
    <>
      <Typography component="span" variant="caption">
        <Typography component="span" variant="caption" sx={{ color: COLORS.muted }}>Visibility:</Typography>{" "}
        <Typography component="span" variant="caption" sx={{ color: COLORS.body, fontWeight: 500 }}>{AVAILABILITY_LABELS[item.availType]}</Typography>
      </Typography>
      <Typography component="span" variant="caption" sx={{ color: COLORS.border }}>·</Typography>
      <Typography component="span" variant="caption">
        <Typography component="span" variant="caption" sx={{ color: COLORS.muted }}>SSO:</Typography>{" "}
        <Typography component="span" variant="caption" sx={{ color: COLORS.body, fontWeight: 500 }}>{item.sso ? "Yes" : "No"}</Typography>
      </Typography>
      <Typography component="span" variant="caption" sx={{ color: COLORS.border }}>·</Typography>
      <Typography component="span" variant="caption">
        <Typography component="span" variant="caption" sx={{ color: COLORS.muted }}>Auto-Prov:</Typography>{" "}
        <Typography component="span" variant="caption" sx={{ color: COLORS.body, fontWeight: 500 }}>{item.autoProv ? "Yes" : "No"}</Typography>
      </Typography>
      {item.externalId && (
        <>
          <Typography component="span" variant="caption" sx={{ color: COLORS.border }}>·</Typography>
          <Typography component="span" variant="caption">
            <Typography component="span" variant="caption" sx={{ color: COLORS.muted }}>External ID:</Typography>{" "}
            <Typography component="span" variant="caption" sx={{ color: COLORS.body, fontWeight: 500 }}>{item.externalId}</Typography>
          </Typography>
        </>
      )}
      {item.explorable && (
        <>
          <Typography component="span" variant="caption" sx={{ color: COLORS.border }}>·</Typography>
          <Typography component="span" variant="caption" sx={{ color: COLORS.muted }}>Explorable</Typography>
        </>
      )}
    </>
  );
}

ServiceDetailInfo.propTypes = {
  item: PropTypes.shape({
    availType: PropTypes.string,
    sso: PropTypes.bool,
    autoProv: PropTypes.bool,
    externalId: PropTypes.string,
    explorable: PropTypes.bool,
  }).isRequired,
};

export default ServiceDetailInfo;
